import React from "react";
import { observer } from "mobx-react";
import loanStyles from "../Loan/Loan.scss";
import { Button } from "~views/shared";

interface IBackButtonProps {
  backText: string;
  onClick: () => void;
}

export const BackButton = observer(({ backText, onClick }: IBackButtonProps) => {
  return (
    <div className={loanStyles.backButtonContainer}>
      <Button color="white" type="secondary" fullWidth title={backText} onClick={onClick} />
    </div>
  );
});
